import { DropdownWithLabel } from '@blueprint/dropdown';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
    DropdownWrapper,
    FiltersLabel,
    LeftWrapper,
    RightWrapper
} from './Options.styles';

const FilterWrapper = styled.div(
    ({ theme: { spacing } }) => css`
        margin: 0;
        width: 100%;
        padding-bottom: ${spacing['24px']};
    `
);

const priceOptions = [
    '10000',
    '20000',
    '30000',
    '40000',
    '50000',
    '60000',
    '70000',
    '80000',
    '90000',
    '100000',
    '110000',
    '120000',
    '125000',
    '130000',
    '140000',
    '150000',
    '160000',
    '170000',
    '180000',
    '190000',
    '200000',
    '210000',
    '220000',
    '230000',
    '240000',
    '250000',
    '275000',
    '300000',
    '325000',
    '350000',
    '375000',
    '400000',
    '425000',
    '450000',
    '475000',
    '500000',
    '550000',
    '600000',
    '650000',
    '700000',
    '750000',
    '800000',
    '850000',
    '900000',
    '950000',
    '1000000',
    '1100000',
    '1200000',
    '1300000',
    '1400000',
    '1500000',
    '1600000',
    '1700000',
    '1800000',
    '1900000',
    '2000000',
    '2100000',
    '2200000',
    '2300000',
    '2400000',
    '2500000',
    '2750000',
    '3000000',
    '3250000',
    '3500000',
    '3750000',
    '4000000',
    '4250000',
    '4500000',
    '4750000',
    '5000000',
    '5500000',
    '6000000',
    '6500000',
    '7000000',
    '7500000',
    '8000000',
    '8500000',
    '9000000',
    '9500000',
    '10000000',
    '12500000',
    '15000000'
];

type prices = typeof priceOptions[number];

export type PriceMin = prices;
export type PriceMax = prices;

type SelectPriceForSaleProps = {
    value: {
        priceMin: PriceMin;
        priceMax: PriceMax;
    };
    onChange: ({
        priceMin,
        priceMax
    }: {
        priceMin: PriceMin;
        priceMax: PriceMax;
    }) => void;
};

export const SelectPriceForSale = ({
    value,
    onChange
}: SelectPriceForSaleProps) => {
    const priceMinOptions =
        value.priceMax !== ''
            ? priceOptions.slice(0, priceOptions.indexOf(value.priceMax) + 1)
            : priceOptions;

    const priceMaxOptions =
        value.priceMin !== ''
            ? priceOptions.slice(priceOptions.indexOf(value.priceMin))
            : priceOptions;

    const priceRangeLabel = 'Price range';
    const maxPriceLabel = 'Max price';
    const minPriceLabel = 'Min price';

    return (
        <FilterWrapper>
            <FiltersLabel htmlFor="modal-price-filter">
                {priceRangeLabel}
            </FiltersLabel>
            <DropdownWrapper>
                <LeftWrapper>
                    <DropdownWithLabel
                        id="price_min_mobile"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                priceMin: e.target.value
                            });
                        }}
                        value={value.priceMin}
                        name="price_min"
                        aria-label="Min Price"
                        data-testid="min_price_modal_mobile"
                        label={minPriceLabel}
                        hasBorderRadius
                    >
                        <option value="">No min</option>
                        {priceMinOptions.map((priceMinOption, index) => {
                            const price = new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0
                            }).format(Number(priceMinOption));

                            return (
                                <option
                                    value={priceMinOption}
                                    key={`modal_price_min_${index}`}
                                >
                                    {price}
                                </option>
                            );
                        })}
                    </DropdownWithLabel>
                </LeftWrapper>
                <RightWrapper>
                    <DropdownWithLabel
                        id="price_max_mobile"
                        onChange={(e) => {
                            onChange({
                                ...value,
                                priceMax: e.target.value
                            });
                        }}
                        value={value.priceMax}
                        name="price_max"
                        aria-label="Max Price"
                        data-testid="max_price_mobile"
                        label={maxPriceLabel}
                        hasBorderRadius
                    >
                        <option value="">No max</option>
                        {priceMaxOptions.map((priceMaxOption, index) => {
                            const price = new Intl.NumberFormat('en-GB', {
                                style: 'currency',
                                currency: 'GBP',
                                maximumFractionDigits: 0,
                                minimumFractionDigits: 0
                            }).format(Number(priceMaxOption));

                            return (
                                <option
                                    value={priceMaxOption}
                                    key={`modal_max_${index}`}
                                >
                                    {price}
                                </option>
                            );
                        })}
                    </DropdownWithLabel>
                </RightWrapper>
            </DropdownWrapper>
        </FilterWrapper>
    );
};
